import { RemoteContractors } from '../../../data/usecases/contractors/remote-contractors'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeContractorRegister = (step: string) => new RemoteContractors(
  `/public/register/contractor/${step}`,
  makeAxiosHttpClient(),
)

export const makeContractorsTerms = () => new RemoteContractors(
  '/public/register/accept-terms/contractor',
  makeAxiosHttpClient(),
)
